export default __webpack_public_path__ + "static/media/a1.e4f9be2f.png";